import { ReactElement } from 'react'
import CheckInfo from '../../CheckInformation/AdditionalCheckInformation'
import ReducedCrossSectionFireCheckInformation from '../../CheckInformation/ReducedCrossSectionFireCheckInformation'
import ReducedCrossSectionFireCheckInformationCLT from '../../CheckInformation/ReducedCrossSectionFireCheckInformationCLT'
import AdditionalVibrationCheckInformation from '../../CheckInformation/VibrationCheckInformation'
import { SHEAR_CHECK_TYPES } from '../constants'

type Props = {
  check: CombinedPositionCheck
}

/** Mirrors `TimberMemberChecksTable` detail panel routing (without settings form fields). */
const MemberCheckDetailContent = ({ check }: Props): ReactElement | null => {
  if (check.check_type === 'Vibration' && check.check_category_type === 'Vibration') {
    return <AdditionalVibrationCheckInformation check={check} />
  }

  if (SHEAR_CHECK_TYPES.has(check.check_type)) {
    return <CheckInfo check={check} />
  }

  if (
    (check.check_type === 'HotDimensioning' && check.check_category_type === 'HotDimensioning') ||
    (check.check_type === 'HotDimensioningCLT' &&
      check.check_category_type === 'HotDimensioningCLT')
  ) {
    return check.check_type === 'HotDimensioning' ? (
      <ReducedCrossSectionFireCheckInformation check={check} />
    ) : (
      <ReducedCrossSectionFireCheckInformationCLT check={check} />
    )
  }

  return <CheckInfo check={check} />
}

export default MemberCheckDetailContent
